import { useState } from 'react';

import { CalendarCardSize } from '@gp/pages/Pipeline/Overview/components/CalendarPanel/enums';
import { DEFAULT_CALENDAR_CARD_SIZE } from '@gp/pages/Pipeline/Overview/components/CalendarPanel/constants';

export default function useScalable(props: {
  // 初始缩放比例，int
  initialSize: CalendarCardSize;
  // 缩放比例集合，int[]，外传传入需要注意缩放比例升序排序
  sizes: CalendarCardSize[];
  onSizeChange?: (size: CalendarCardSize) => void;
}) {
  const { initialSize, sizes, onSizeChange } = props;

  // 缩放比例
  const [size, setSize] = useState<CalendarCardSize>(initialSize ?? DEFAULT_CALENDAR_CARD_SIZE);

  const check = (): { flag: boolean; index: number } => {
    if (!Array.isArray(sizes) || !sizes.length) return { flag: false, index: -1 };
    const sizeIdx = sizes.findIndex((s) => s === size);
    return { flag: sizeIdx !== -1, index: sizeIdx };
  };

  const changeSizeByIndex = (getNewSizeIdx: (currentSizeIdx: number) => number) => {
    const checkRes = check();
    if (!checkRes.flag) return;
    const sizeIdxNew = getNewSizeIdx(checkRes.index);
    const sizeNew = sizes[sizeIdxNew];
    setSize(sizeNew);
    onSizeChange?.(sizeNew);
  };

  // 点击放大
  const handleBiggerSize = () => {
    changeSizeByIndex((currentSizeIdx) => {
      // 放大，当前size的索引 + 1
      const newSizeIdx = currentSizeIdx + 1;
      // 确保索引不越界（超过最大索引）
      return Math.min(newSizeIdx, sizes.length - 1);
    });
  };

  // 点击缩小
  const handleSmallerSize = () => {
    changeSizeByIndex((currentSizeIdx) => {
      // 放大，当前size的索引 - 1
      const newSizeIdx = currentSizeIdx - 1;
      // 确保索引不越界（小于最小索引0）
      return Math.max(newSizeIdx, 0);
    });
  };

  // 重置为默认尺寸
  const reset = () => {
    setSize(DEFAULT_CALENDAR_CARD_SIZE);
    onSizeChange?.(DEFAULT_CALENDAR_CARD_SIZE);
  };

  return { size, onSmallerSize: handleSmallerSize, onBiggerSize: handleBiggerSize, reset };
}
